import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/lib/AuthContext';
import AppLayout from '@/components/AppLayout';
import LandingPage from '@/pages/LandingPage';
import { PrivacyPage, TermsPage, DisclaimerStubPage } from '@/pages/LegalStubs';
import SignInPage from '@/pages/SignInPage';
import SignUpPage from '@/pages/SignUpPage';
import HomePage from '@/pages/HomePage';
import MedicationsPage from '@/pages/MedicationsPage';
import AddMedicationPage from '@/pages/AddMedicationPage';
import MedicationDetailPage from '@/pages/MedicationDetailPage';
import InteractionsPage from '@/pages/InteractionsPage';
import InteractionDetailPage from '@/pages/InteractionDetailPage';
import TodayPage from '@/pages/TodayPage';
import ProfilePage from '@/pages/ProfilePage';
import HistoryPage from '@/pages/HistoryPage';
import SummaryPage from '@/pages/SummaryPage';
import '@/App.css';

function AuthGate() {
  const { status } = useAuth();
  if (status === 'loading') {
    return (
      <div className="flex items-center justify-center h-screen" style={{ backgroundColor: '#F7FAFC' }}>
        <div className="animate-spin h-8 w-8 border-4 rounded-full" style={{ borderColor: '#D7E2E8', borderTopColor: '#D77A52' }} />
      </div>
    );
  }
  if (status !== 'authenticated') return <Navigate to="/" replace />;
  return <AppLayout />;
}

function GuestGate() {
  const { status } = useAuth();
  if (status === 'loading') {
    return (
      <div className="flex items-center justify-center h-screen" style={{ backgroundColor: '#F7FAFC' }}>
        <div className="animate-spin h-8 w-8 border-4 rounded-full" style={{ borderColor: '#D7E2E8', borderTopColor: '#D77A52' }} />
      </div>
    );
  }
  if (status === 'authenticated') return <Navigate to="/home" replace />;
  return <Outlet />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Guest routes — landing + auth */}
          <Route element={<GuestGate />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/signup" element={<SignUpPage />} />
          </Route>

          {/* Authenticated routes inside AppLayout */}
          <Route element={<AuthGate />}>
            <Route path="/home" element={<HomePage />} />
            <Route path="/medications" element={<MedicationsPage />} />
            <Route path="/medications/add" element={<AddMedicationPage />} />
            <Route path="/medications/:id" element={<MedicationDetailPage />} />
            <Route path="/interactions" element={<InteractionsPage />} />
            <Route path="/interactions/:pairId" element={<InteractionDetailPage />} />
            <Route path="/today" element={<TodayPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/summary" element={<SummaryPage />} />
          </Route>

          {/* Public legal pages — accessible to all */}
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/disclaimer" element={<DisclaimerStubPage />} />

          {/* Backward compat: /welcome → / */}
          <Route path="/welcome" element={<Navigate to="/" replace />} />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
